import React, { Component } from "react";
import ReactHowler from "react-howler";

class MusicPlayer extends Component {
  render() {
    const song = this.props;
    return (
      <>
        <ReactHowler
          src={[song.url]}
          playing={song.playing}
          volume={song.volume}
          loop={song.loop}
          ref={(ref) => (this.player = ref)}
        />
      </>
    );
  }
}

export default MusicPlayer;
